"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pietralunga": {
    "5c38d417": [{
      "hkey": "ceac2c5d",
      "slug": "pietralunga",
      "name": "Pietralunga",
      "primary": true,
      "skipSearch": false
    }],
    "castel-guelfo": [{
      "hkey": "ceac2c5d",
      "slug": "pietralunga",
      "name": "Pietralunga",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "83da3260": [{
      "hkey": "ceac2c5d",
      "slug": "pietralunga",
      "name": "Pietralunga",
      "primary": true,
      "skipSearch": false
    }],
    "colle-antico": [{
      "hkey": "ceac2c5d",
      "slug": "pietralunga",
      "name": "Pietralunga",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "50afc57d": [{
      "hkey": "ceac2c5d",
      "slug": "pietralunga",
      "name": "Pietralunga",
      "primary": true,
      "skipSearch": false
    }],
    "corniole": [{
      "hkey": "ceac2c5d",
      "slug": "pietralunga",
      "name": "Pietralunga",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a671a519": [{
      "hkey": "ceac2c5d",
      "slug": "pietralunga",
      "name": "Pietralunga",
      "primary": true,
      "skipSearch": false
    }],
    "san-biagio": [{
      "hkey": "ceac2c5d",
      "slug": "pietralunga",
      "name": "Pietralunga",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6fb16fb9": [{
      "hkey": "ceac2c5d",
      "slug": "pietralunga",
      "name": "Pietralunga",
      "primary": true,
      "skipSearch": false
    }],
    "san-faustino": [{
      "hkey": "ceac2c5d",
      "slug": "pietralunga",
      "name": "Pietralunga",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;